import { Injectable } from '@angular/core';
import { NbThemeService } from '@nebular/theme';
import { PRIMENG_DARK_MODE_CLASS } from '@frontend/services/primeng-dark-mode';
import { LocalStorage } from 'ngx-webstorage';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  isLightThemeActive$ = new BehaviorSubject<boolean>(null);
  @LocalStorage('IS_LIGHT_THEME_ACTIVE', true)
  private isLightThemeActive: boolean;

  constructor(private themeService: NbThemeService) {
    this.isLightThemeActive$.subscribe(this.changeTheme.bind(this));
    this.isLightThemeActive$.next(this.isLightThemeActive);
  }

  changeTheme(): void {
    const lightTheme = this.isLightThemeActive$.value;

    if (lightTheme === null) {
      return;
    }

    const materialThemeLink = document.getElementById('material-theme') as HTMLLinkElement;
    document.documentElement.classList.toggle(PRIMENG_DARK_MODE_CLASS, !lightTheme);

    if (lightTheme) {
      this.themeService.changeTheme('default');
      materialThemeLink.href = 'material-light.css';
      this.isLightThemeActive = true;
      return;
    }

    this.themeService.changeTheme('dark');
    materialThemeLink.href = 'material-dark.css';
    this.isLightThemeActive = false;
  }

  toggleThemeState(): void {
    this.isLightThemeActive$.next(!this.isLightThemeActive$.value);
  }
}
